export const isRadioField = (fieldType) => fieldType === "Radio Field";
export const isNumericField = (fieldType) => fieldType === "Numeric Field";
export const isCheckboxField = (fieldType) => fieldType === "Checkbox Field";
